import ModalFilters from '@/language/en/components/filter/ModalFilters';

export default {
  ModalFilters,
};
